import type { PushKeyResponse, PushSubscriptionInput } from '@orbit-sync/shared-types';
import { request } from './client.js';

/** `GET /api/v1/push/key` - the server's VAPID key, or `null` when push is off. */
export function getKey(): Promise<PushKeyResponse> {
  return request<PushKeyResponse>('/push/key');
}

/** `POST /api/v1/push/subscriptions` - registers this browser for pushes. */
export function subscribe(subscription: PushSubscriptionInput): Promise<void> {
  return request<void>('/push/subscriptions', { method: 'POST', body: subscription });
}

/** `DELETE /api/v1/push/subscriptions` - stops pushes to this browser. */
export function unsubscribe(endpoint: string): Promise<void> {
  return request<void>('/push/subscriptions', { method: 'DELETE', body: { endpoint } });
}
